import React from 'react';
import { InlineEdit } from './inline-edit';
import { Input } from './input';

type InlineTextEditProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  displayValue?: (value: string) => string;
  small?: boolean;
  editOn?: 'click' | 'hover' | 'focus';
  disabled?: boolean;
  className?: string;
  type?: 'text' | 'number' | 'email' | 'password' | 'search' | 'tel' | 'url';
  inputMode?: 'numeric' | 'text' | 'decimal' | 'email' | 'search' | 'tel' | 'url';
  [key: string]: unknown; // Allow other Input props
};

export function InlineTextEdit({
  value,
  onChange,
  placeholder,
  displayValue,
  small = false,
  editOn = 'hover',
  disabled = false,
  className,
  type = 'text',
  inputMode,
  ...inputProps
}: InlineTextEditProps) {
  const handleDisplay = (val: string) => {
    if (displayValue) {
      return displayValue(val);
    }
    return val || placeholder || '';
  };

  return (
    <InlineEdit<string>
      value={value}
      onChange={onChange}
      renderDisplay={handleDisplay}
      renderEditor={(val, handleChange, onBlur, onFocus) => (
        <Input
          name="inline-text-edit"
          value={val}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          type={type}
          inputMode={inputMode}
          small={small}
          disabled={disabled}
          {...inputProps}
        />
      )}
      editOn={editOn}
      disabled={disabled}
      className={className}
    />
  );
}
